var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("02 拓撲階層")]), _vm._v(" —— 此案場有哪些節點、上下游關係、電錶名稱校正。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_vm._v("最上游那一列的「上游節點編號」留空；其餘必須指到同案場已存在的節點，否則存不進去。")]), _c('li', [_c('strong', [_vm._v("INV／STR 陣列位置不可由節點編號推算")]), _vm._v("。f001 的 "), _c('code', [_vm._v("pv_v[0]")]), _vm._v(" 有 11 格但只有 9 串，空接會跳號（見 ADR-0011）。 權威來源是主檔 05_MPPT串列對應。 ")]), _c('li', [_vm._v(" STR 的節點編號是 "), _c('code', [_vm._v("INV<INV序號>-<MPPT編號>-<該MPPT內第幾格>")]), _vm._v(" （例 "), _c('code', [_vm._v("INV1-3-1")]), _vm._v("），跟 05 的串列編號同一組值。MPPT 分組遙測裡沒有， 所以"), _c('strong', [_vm._v("先把 05 建好、再按「由遙測產生」")]), _vm._v("；05 還沒建的話會退回舊的整台連號 "), _c('code', [_vm._v("INV1-STR6")]), _vm._v("，之後要重編。 ")]), _c('li', [_vm._v("同一個陣列位置只能被一個節點認領，重覆會被 "), _c('code', [_vm._v("uq_topology_array_slot")]), _vm._v(" 擋下來。")])])]), _c('MasterDataTable', _vm._g({
    attrs: {
      "table": "inverter_topology_nodes",
      "def": _vm.def,
      "site-code": _vm.siteCode
    }
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };